import script from "./invoices-list.vue?vue&type=script&setup=true&lang=js"
export * from "./invoices-list.vue?vue&type=script&setup=true&lang=js"

import "./invoices-list.vue?vue&type=style&index=0&id=e98e7212&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e98e7212"]])

export default __exports__